import script from "./Fetch.vue?vue&type=script&lang=js"
export * from "./Fetch.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__